export function searchPanel() {
  $('.toggle-search').click(function(e){
    e.preventDefault();
    if(!$('body').hasClass('open-search')) {
      $('body[class*="open-"]').removeClass(function (index, css) { return (css.match (/(^|\s)open-\S+/g) || []).join(' '); });
      setTimeout(function(){
        $('#search-input').focus()
      }, 400)
    }
    $('body').toggleClass('open-search')
  })
  $('.header__search').click(function(e){
    if(e.target == e.currentTarget) {
      e.preventDefault();
      $('body').removeClass('open-search')
    }
  })
}

export function launchSearch() {
  var livesearch = setTimeout( function() {}, 10);
  $('#search-input').keyup(function(){
    var keyword = $(this).val();
    clearTimeout(livesearch);
    if(keyword) {
      $(".search__content").addClass("loading");
      livesearch = setTimeout( function() {
        if(keyword) {
          var data = { 'action': 'ajax_posts', 'search': keyword };
          jQuery.post(window.latino.ajaxurl, data, function(response) {
            setTimeout(function(){
              $(".search__content").removeClass("loading");
              if(response){ $(".search__content").html(response); }
            }, 500)
          });
        } else {
          $(".search__content").removeClass("loading").html("");
        }
      }, 800);
    } else {
      $(".search__content").removeClass("loading").html("");
    }
  });
}
